import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { SphereBarChart } from "@components/common/sphere-bar-chart/sphere-bar-chart";
import { Box } from "@mui-wrapper";
import { ProjectChartController } from "@pages/project-details/project-overview/project-chart/project-chart-controller";
import { ProjectChartEmpty } from "@pages/project-details/project-overview/project-chart/project-chart-empty";
import { useAppParams } from "@router/router-helper";
import { useCompanyId } from "@context-providers/company-id-provider";
import { fetchingAnalyticsFlagsSelector, hasProjectSpheresSelector, projectChartSelector } from "@store/analytics/analytics-selector";
import { fetchProjectStats } from "@store/analytics/analytics-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { useEffect } from "react";

/* eslint-disable @typescript-eslint/no-magic-numbers -- aspect ratio value */
/** Chart aspect ratio */
const CHART_ASPECT_RATIO = 21 / 9;
/* eslint-enable @typescript-eslint/no-magic-numbers */

/** Renders an analytics chart that displays the current project stats */
export function ProjectChart(t0) {
  const $ = _c(14);
  const {
    isLoading
  } = t0;
  const {
    projectId
  } = useAppParams();
  const companyId = useCompanyId();
  const dispatch = useAppDispatch();
  const {
    isFetchingProjectStats
  } = useAppSelector(fetchingAnalyticsFlagsSelector);
  const chartData = useAppSelector(projectChartSelector);
  const hasProjectSpheres = useAppSelector(hasProjectSpheresSelector);
  const isFetching = isLoading || isFetchingProjectStats;
  const shouldShowSkeleton = isFetching || !chartData;
  let t1;
  let t2;
  if ($[0] !== companyId || $[1] !== dispatch || $[2] !== projectId) {
    t1 = () => {
      if (projectId) {
        dispatch(fetchProjectStats({
          projectId,
          companyId
        }));
      }
    };
    t2 = [companyId, dispatch, projectId];
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = projectId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!isFetching && hasProjectSpheres === false) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ProjectChartEmpty />;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== shouldShowSkeleton) {
    t3 = shouldShowSkeleton ? <Skeleton variant="rectangular" width="100%"><ProjectChartController /></Skeleton> : <ProjectChartController />;
    $[6] = shouldShowSkeleton;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== chartData || $[9] !== shouldShowSkeleton) {
    t4 = <SphereBarChart data={chartData} aspectRatio={CHART_ASPECT_RATIO} shouldShowSkeleton={shouldShowSkeleton} shouldHideTitle={true} />;
    $[8] = chartData;
    $[9] = shouldShowSkeleton;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <Box>{t3}{t4}</Box>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}